import { useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { registerUser } from "core/Auth";
import { useAppDispatch } from "store/hooks";
import { login } from "store/slices/userSlice";
import UserInfoForm from "./UserInfoForm";
import LanguagesForm from "./LanguagesForm";
import { IUserInfo } from "common/interfaces/IUserInfo";
import InterestsForm from "./InterestsForm/indext";
import Steps from "components/Steps";
import { convertObjToArr } from "utils/handleObjects";
import SkillsForm from "./SkillsForm/indext";

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  height: calc(100vh - 60px);
  overflow-y: scroll;
`;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 80%;
  max-width: 1000px;
  margin-top: 32px;
`;

const ContentWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

const Heading = styled.h1`
  margin-bottom: 32px;
`;

const steps = ["data", "language", "interests", "skills"];

const Register = () => {
  const { t } = useTranslation("forms");
  const dispatch = useAppDispatch();
  const [selectedLangs, setSelectedLangs] = useState<any>({});
  const [selectedInterests, setSelectedInterests] = useState<any>({});
  const [selectedSkills, setSelectedSkills] = useState<string[]>([]);
  const [currentStep, setCurrentStep] = useState(0);
  const [userData, setUserData] = useState<IUserInfo>({
    name: "",
    username: "",
    email: "",
    password: "",
  });

  const onSubmit = async (e: any) => {
    e.preventDefault();

    const allData = {
      ...userData,
      languages: convertObjToArr(selectedLangs),
      interests: convertObjToArr(selectedInterests),
      skills: selectedSkills,
    };

    try {
      const data = await registerUser(allData);

      if (data.email) {
        dispatch(login({ email: userData.email, password: userData.password }));
      }
    } catch (e: any) {
      console.log(e);
    }
  };

  const renderCurrentForm = () => {
    switch (currentStep) {
      case 0:
        return <UserInfoForm userData={userData} setUserData={setUserData} />;
      case 1:
        return (
          <LanguagesForm
            selected={selectedLangs}
            setSelected={setSelectedLangs}
          />
        );
      case 2:
        return (
          <InterestsForm
            selected={selectedInterests}
            setSelected={setSelectedInterests}
          />
        );
      case 3:
        return (
          <SkillsForm
            selected={selectedSkills}
            setSelected={setSelectedSkills}
          />
        );
    }
  };

  return (
    <Wrapper>
      <FormWrapper>
        <Heading>{t("registerTitle")}</Heading>
        <Steps
          steps={steps}
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
          submitLabel={t("forms:completeRegistration")}
          onSubmit={onSubmit}
        >
          <ContentWrapper>{renderCurrentForm()}</ContentWrapper>
        </Steps>
      </FormWrapper>
    </Wrapper>
  );
};

export default Register;
